var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { trunTo } from '@vital-ui/react-utils';
import { defaultTheme } from '@vital-ui/react-theme';
var badgeTransformStyle = function (_a) {
    var size = _a.size, circle = _a.circle, label = _a.label, theme = _a.theme;
    if (size === 'xlarge') {
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      padding: 0 5px;\n      border-radius: 0.75rem;\n      font-size: 0.725rem;\n      left: ", ";\n      right: ", ";\n      top: ", ";\n    "], ["\n      padding: 0 5px;\n      border-radius: 0.75rem;\n      font-size: 0.725rem;\n      left: ", ";\n      right: ", ";\n      top: ",
            ";\n    "])), circle ? '70%' : 'auto', circle ? 'auto' : '-12%', circle
            ? 0
            : "calc(" + theme.avatar[size].badgeHeight + " / -2)");
    }
    // circle badge style
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: 0;\n    border-radius: 50%;\n    font-size: 0;\n    width: ", ";\n    height: ", ";\n    right: calc(", " / -2);\n    top: ", ";\n    left: ", ";\n    right: ", ";\n\n    &:before {\n      content: '';\n      position: absolute;\n      top: calc(50% - (3px / 2));\n      left: calc(50% - (3px / 2));\n      background: ", ";\n      border-radius: 50%;\n      width: 3px;\n      height: 3px;\n    }\n  "], ["\n    padding: 0;\n    border-radius: 50%;\n    font-size: 0;\n    width: ", ";\n    height: ", ";\n    right: calc(", " / -2);\n    top: ",
        ";\n    left: ", ";\n    right: ",
        ";\n\n    &:before {\n      content: '';\n      position: absolute;\n      top: calc(50% - (3px / 2));\n      left: calc(50% - (3px / 2));\n      background: ", ";\n      border-radius: 50%;\n      width: 3px;\n      height: 3px;\n    }\n  "])), theme.avatar[size].badgeHeight, theme.avatar[size].badgeHeight, theme.avatar[size].badgeHeight, circle
        ? 0
        : "calc(" + theme.avatar[size].badgeHeight + " / -2)", circle ? '70%' : 'auto', circle
        ? 'auto'
        : "calc" + theme.avatar[size].badgeHeight + " / -2", label ? '#fff' : 'transparent');
};
var Root = styled('span')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  background-color: ", ";\n  color: ", ";\n  vertical-align: middle;\n  height: ", ";\n  line-height: ", ";\n  ", ";\n"], ["\n  position: absolute;\n  background-color: ", ";\n  color: ", ";\n  vertical-align: middle;\n  height: ", ";\n  line-height: ", ";\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.avatar.badgeBg;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var size = _a.size, theme = _a.theme;
    return theme.avatar[size].badgeHeight;
}, function (_a) {
    var size = _a.size, theme = _a.theme;
    return theme.avatar[size].badgeHeight;
}, badgeTransformStyle);
Root.defaultProps = {
    theme: defaultTheme,
};
export var AvatarBadge = function (_a) {
    var label = _a.label, _b = _a.size, size = _b === void 0 ? 'medium' : _b, _c = _a.circle, circle = _c === void 0 ? false : _c, _d = _a.style, style = _d === void 0 ? undefined : _d, _e = _a.className, className = _e === void 0 ? undefined : _e;
    return (React.createElement(Root, { label: label, size: size, circle: circle, style: style, className: className }, size === 'xlarge' ? trunTo(label) : null));
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=AvatarBadge.js.map